:root {
  color: #f7f2ec;
  background: #0b0910;
  font-family:
    Inter,
    ui-sans-serif,
    system-ui,
    -apple-system,
    BlinkMacSystemFont,
    "Segoe UI",
    sans-serif;
  font-synthesis: none;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  --bg: #0b0910;
  --panel: rgba(24, 19, 31, 0.88);
  --panel-strong: rgba(36, 27, 45, 0.96);
  --line: rgba(255, 255, 255, 0.12);
  --muted: #aaa2b8;
  --text: #f7f2ec;
  --acid: #d6ff4f;
  --amber: #ffb84d;
  --red: #ff355d;
  --cyan: #73f4ff;
  --shadow: 0 20px 50px rgba(0, 0, 0, 0.36);
  --ease-out: cubic-bezier(0.2, 0.8, 0.2, 1);
  --focus-ring: 0 0 0 4px rgba(214, 255, 79, 0.11);
}

* {
  box-sizing: border-box;
  -webkit-user-select: none;
  user-select: none;
}
body {
  margin: 0;
  min-width: 320px;
  min-height: 100vh;
  background:
    radial-gradient(
      circle at 18% 4%,
      rgba(214, 255, 79, 0.13),
      transparent 25rem
    ),
    radial-gradient(
      circle at 86% 0%,
      rgba(255, 53, 93, 0.16),
      transparent 28rem
    ),
    linear-gradient(145deg, #0b0910 0%, #14111c 58%, #08070b 100%);
}
button,
input,
select {
  font: inherit;
}
input,
textarea,
select,
option,
code,
pre,
.selectable {
  -webkit-user-select: text;
  user-select: text;
}
button {
  cursor: pointer;
  border: 0;
  -webkit-tap-highlight-color: transparent;
}
button:disabled {
  cursor: not-allowed;
  opacity: 0.52;
}
button:focus-visible,
summary:focus-visible {
  outline: 3px solid rgba(214, 255, 79, 0.42);
  outline-offset: 3px;
}
button:active:not(:disabled) {
  transform: translateY(0);
}
code {
  color: var(--acid);
}

.app-shell {
  width: min(1520px, calc(100% - 24px));
  margin: 0 auto;
  padding: 14px 0 22px;
}
.panel {
  border: 1px solid var(--line);
  background: var(--panel);
  border-radius: 22px;
  padding: 18px;
  box-shadow: var(--shadow);
  backdrop-filter: blur(18px);
}
.top-panel {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(300px, 360px);
  gap: 16px;
  align-items: center;
  margin-bottom: 14px;
  overflow: hidden;
  position: relative;
}
.top-panel:after {
  content: "";
  position: absolute;
  inset: auto -8rem -10rem auto;
  width: 22rem;
  height: 22rem;
  background: radial-gradient(
    circle,
    rgba(214, 255, 79, 0.18),
    transparent 68%
  );
  pointer-events: none;
}
.title-block {
  position: relative;
  z-index: 1;
}
.title-button {
  all: unset;
  display: inline-block;
  border-radius: 12px;
  cursor: pointer;
  transition:
    color 0.16s ease,
    text-shadow 0.16s ease,
    transform 0.16s var(--ease-out);
}
.title-button:hover {
  color: var(--acid);
  text-shadow: 0 0 22px rgba(214, 255, 79, 0.22);
  transform: translateY(-1px);
}
.title-button:focus-visible {
  outline: 3px solid rgba(214, 255, 79, 0.48);
  outline-offset: 5px;
}
h1,
h2,
h3 {
  margin: 0;
  line-height: 1.05;
}
h1 {
  font-size: 3.45rem;
  letter-spacing: 0;
  line-height: 1.12;
}
h2 {
  font-size: 1.12rem;
  letter-spacing: 0;
}
h3 {
  font-size: 0.92rem;
  margin-top: 16px;
  color: #fff;
}
.hint,
.summary {
  color: var(--muted);
  line-height: 1.45;
}
.write-card {
  position: relative;
  z-index: 1;
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 12px;
  align-items: center;
  border-radius: 18px;
  padding: 12px;
  background: linear-gradient(
    140deg,
    rgba(255, 53, 93, 0.22),
    rgba(214, 255, 79, 0.1)
  );
  border: 1px solid var(--line);
}
.slot-count {
  display: grid;
  gap: 1px;
  min-width: 82px;
}
.slot-count span {
  color: var(--acid);
  font-weight: 1000;
  font-size: 3rem;
  letter-spacing: 0;
  line-height: 1;
}
.slot-count small {
  color: var(--muted);
}
.big-red {
  border-radius: 18px;
  padding: 18px 22px;
  color: #190407;
  background: linear-gradient(135deg, var(--red), #ff8a35);
  box-shadow: 0 18px 46px rgba(255, 53, 93, 0.25);
  font-size: 1.2rem;
  font-weight: 1000;
  letter-spacing: 0;
  text-transform: uppercase;
  width: 100%;
}
.cancel-button {
  grid-column: 1 / -1;
}

.progress-mini {
  grid-column: 1 / -1;
  display: grid;
  gap: 6px;
  color: var(--muted);
  font-weight: 800;
  font-size: 0.78rem;
}
.progress-mini div {
  height: 10px;
  border-radius: 999px;
  border: 1px solid var(--line);
  background: rgba(255, 255, 255, 0.05);
  overflow: hidden;
}
.progress-mini i {
  display: block;
  height: 100%;
  background: linear-gradient(90deg, var(--acid), var(--cyan));
}
.app-modal {
  position: fixed;
  inset: 0;
  z-index: 999;
  display: grid;
  place-items: center;
  padding: 12px;
}
.modal-backdrop {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.58);
  backdrop-filter: blur(3px);
  animation: fade-in 0.16s var(--ease-out);
}
.modal-dialog {
  position: relative;
  width: min(580px, 100%);
  max-height: min(88vh, 720px);
  overflow: auto;
  color: var(--text);
  border: 1px solid rgba(255, 255, 255, 0.16);
  border-radius: 18px;
  background:
    linear-gradient(180deg, rgba(27, 21, 34, 0.98), rgba(14, 11, 19, 0.98)),
    var(--panel-strong);
  box-shadow: 0 30px 120px rgba(0, 0, 0, 0.58);
  animation: modal-in 0.18s var(--ease-out);
}
.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  padding: 14px 16px 12px;
  border-bottom: 1px solid var(--line);
}
.modal-header h2 {
  font-size: 1rem;
}
.modal-close {
  width: 34px;
  height: 34px;
  border-radius: 999px;
  color: var(--text);
  background: rgba(255, 255, 255, 0.07);
  border: 1px solid var(--line);
  font-weight: 1000;
  line-height: 1;
}
.modal-close:hover {
  border-color: rgba(214, 255, 79, 0.4);
}
.modal-body {
  display: grid;
  gap: 10px;
  padding: 15px 16px 8px;
}
.modal-body p {
  margin: 0;
  color: #ddd7e8;
  line-height: 1.46;
}
.license-note {
  display: grid;
  gap: 6px;
  margin-top: 4px;
  padding: 10px 12px;
  border: 1px solid rgba(214, 255, 79, 0.2);
  border-radius: 14px;
  background: rgba(214, 255, 79, 0.07);
}
.license-note strong {
  color: #fff;
  font-size: 0.92rem;
  line-height: 1.38;
}
.modal-notes {
  margin: 0;
  padding-left: 18px;
  color: var(--muted);
  line-height: 1.45;
}
.about-support {
  display: grid;
  gap: 10px;
  margin-top: 6px;
  padding-top: 14px;
  border-top: 1px solid var(--line);
}
.about-support-copy {
  color: #fff;
  font-weight: 900;
}
.kofi-frame {
  display: block;
  width: 100%;
  height: min(520px, 62vh);
  min-height: 360px;
  border: 0;
  border-radius: 12px;
  background: #f9f9f9;
}
.modal-footer {
  display: flex;
  justify-content: flex-end;
  padding: 8px 16px 16px;
}
.modal-ok {
  min-width: 96px;
}
.workspace {
  display: grid;
  grid-template-columns: minmax(300px, 360px) minmax(0, 1fr);
  gap: 14px;
  align-items: start;
}
.setup-panel,
.main-panel {
  min-height: calc(100vh - 170px);
}
.setup-panel {
  display: flex;
  flex-direction: column;
}
.panel-heading {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
}
.compact-heading {
  align-items: center;
}
label {
  display: grid;
  gap: 6px;
  color: #ddd7e8;
  font-weight: 800;
  font-size: 0.84rem;
  margin: 10px 0;
}
input,
select {
  width: 100%;
  color: var(--text);
  background: #100d17;
  border: 1px solid var(--line);
  border-radius: 12px;
  padding: 10px 11px;
  outline: none;
  transition:
    border-color 0.16s ease,
    background 0.16s ease,
    box-shadow 0.16s ease;
}
input:focus,
select:focus {
  border-color: rgba(214, 255, 79, 0.65);
  background: #14101d;
  box-shadow: var(--focus-ring);
}
input[type="range"] {
  accent-color: var(--acid);
  padding: 0;
}
small {
  color: var(--muted);
}
.secondary,
.segmented button,
.tabbar button {
  color: var(--text);
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid var(--line);
  border-radius: 999px;
  padding: 8px 12px;
  font-weight: 900;
  transition:
    color 0.16s ease,
    transform 0.16s var(--ease-out),
    border-color 0.16s ease,
    background 0.16s ease,
    box-shadow 0.16s ease;
}
.secondary:hover,
.segmented button:hover,
.tabbar button:hover {
  transform: translateY(-1px);
  border-color: rgba(214, 255, 79, 0.35);
  background: rgba(255, 255, 255, 0.085);
  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.14);
}
.secondary.subtle {
  padding: 7px 10px;
  font-size: 0.78rem;
  background: rgba(255, 255, 255, 0.04);
}
.secondary.danger {
  color: #ffd3dc;
  border-color: rgba(255, 53, 93, 0.28);
}
.segmented,
.status-row,
.button-row,
.check-row,
.quick-ranges {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  align-items: center;
}
.segmented {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  width: 100%;
  margin: 10px 0;
}
.segmented button {
  width: 100%;
}
.segmented button.active,
.tabbar button.active {
  background: var(--acid);
  color: #121212;
  border-color: var(--acid);
  box-shadow: 0 8px 18px rgba(214, 255, 79, 0.12);
}
.status-row {
  margin: 10px 0;
}
.status-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border-radius: 999px;
  padding: 7px 10px;
  font-size: 0.78rem;
  font-weight: 900;
  border: 1px solid var(--line);
}
.status-pill:before {
  content: "";
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: currentColor;
}
.status-pill.ok {
  color: var(--acid);
  background: rgba(214, 255, 79, 0.07);
}
.status-pill.not-ok {
  color: var(--amber);
  background: rgba(255, 184, 77, 0.08);
}
.button-row {
  margin-top: 12px;
}
.button-row.no-margin {
  margin-top: 0;
  justify-content: flex-end;
}
.dump-map {
  margin-top: 12px;
}
.dump-map-toolbar {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
  align-items: center;
}
.map-toggle {
  text-align: center;
}
.setup-panel > .button-row {
  display: grid;
  grid-template-columns: 1fr;
  gap: 8px;
  margin-top: 10px;
}
.setup-panel .dump-map-toolbar .secondary,
.setup-panel > .button-row .secondary {
  min-height: 38px;
  justify-content: center;
  border-radius: 12px;
  padding: 9px 11px;
  font-size: 0.83rem;
  line-height: 1.14;
  background: rgba(255, 255, 255, 0.045);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.025);
}
.setup-panel .dump-map-toolbar .secondary:hover,
.setup-panel > .button-row .secondary:hover {
  border-color: rgba(214, 255, 79, 0.28);
  background: rgba(255, 255, 255, 0.065);
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.04),
    0 8px 18px rgba(0, 0, 0, 0.12);
}
.setup-panel .secondary:disabled {
  opacity: 1;
  color: rgba(247, 242, 236, 0.42);
  border-color: rgba(255, 255, 255, 0.08);
  background: rgba(255, 255, 255, 0.025);
  box-shadow: none;
}
.setup-panel .secondary:disabled:hover {
  transform: none;
  border-color: rgba(255, 255, 255, 0.08);
  background: rgba(255, 255, 255, 0.025);
  box-shadow: none;
}
.map-list {
  display: grid;
  gap: 7px;
  margin-top: 8px;
  padding: 9px;
  border: 1px solid var(--line);
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.03);
}
.map-empty {
  margin: 0;
}
.map-entry,
.map-footer {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 8px;
  align-items: center;
}
.map-entry {
  padding: 8px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.035);
  transition:
    border-color 0.16s ease,
    background 0.16s ease;
}
.map-entry:hover {
  border-color: rgba(255, 255, 255, 0.14);
  background: rgba(255, 255, 255, 0.05);
}
.map-entry-main {
  display: grid;
  gap: 2px;
  min-width: 0;
}
.map-entry-main strong,
.map-entry-main span,
.map-footer span {
  overflow-wrap: anywhere;
}
.map-entry-main strong {
  color: var(--acid);
  font-size: 0.78rem;
  line-height: 1.25;
}
.map-entry-main span,
.map-footer span {
  color: var(--muted);
  font-size: 0.78rem;
  line-height: 1.3;
}
.map-remove {
  padding: 6px 9px;
  font-size: 0.76rem;
}
.grid {
  display: grid;
  gap: 12px;
}
.grid.two {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid.three {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.grid.compact {
  gap: 10px;
  margin-top: 10px;
}
.range-select-grid {
  grid-template-columns: 1fr;
}
.tabbar-row {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  margin-bottom: 14px;
  border-bottom: 1px solid var(--line);
  padding-bottom: 12px;
}
.tabbar {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  align-items: center;
}
.tab-content {
  max-height: calc(100vh - 235px);
  overflow: auto;
  padding: 3px 4px 3px 0;
  scrollbar-color: rgba(214, 255, 79, 0.28) rgba(255, 255, 255, 0.04);
  scrollbar-width: thin;
}
.recipe-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(190px, 1fr));
  gap: 10px;
}
.recipe-card {
  position: relative;
  text-align: left;
  color: var(--text);
  border: 1px solid var(--line);
  background: rgba(255, 255, 255, 0.045);
  border-radius: 16px;
  padding: 13px;
  display: grid;
  align-items: center;
  min-height: 62px;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.03);
  transition:
    transform 0.18s var(--ease-out),
    border-color 0.18s ease,
    background 0.18s ease,
    box-shadow 0.18s ease;
}
.recipe-card strong {
  color: #fff;
  font-size: 0.98rem;
  transition: color 0.18s ease;
}
.recipe-card:hover {
  z-index: 1;
  transform: translateY(-1px);
  border-color: rgba(214, 255, 79, 0.24);
  background: rgba(255, 255, 255, 0.06);
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.05),
    0 12px 28px rgba(0, 0, 0, 0.16);
}
.recipe-card:hover strong {
  color: #fffbd7;
}
.recipe-card.active {
  border-color: rgba(214, 255, 79, 0.65);
  background: rgba(214, 255, 79, 0.1);
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.06),
    0 0 0 1px rgba(214, 255, 79, 0.04);
}
.recipe-card.local {
  border-style: dashed;
}
.recipe-card small {
  color: var(--cyan);
  font-size: 0.72rem;
  font-weight: 900;
}
.manual-grid,
.activity-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(320px, 0.9fr);
  gap: 18px;
}
.slider-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px 16px;
  margin: 12px 0;
}
.recipe-shape-controls {
  display: flex;
  gap: 10px;
  align-items: center;
  margin: 12px 0 14px;
}
.shape-toggle {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0;
  color: #fff;
  border: 1px solid rgba(214, 255, 79, 0.28);
  background: rgba(214, 255, 79, 0.07);
  border-radius: 14px;
  padding: 10px 12px;
}
.shape-toggle input {
  width: auto;
  accent-color: var(--acid);
}
.manual-current-recipe {
  margin: 0;
}
.manual-recipe-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  flex-wrap: wrap;
}
.slider-label span {
  display: flex;
  justify-content: space-between;
  gap: 12px;
}
.slider-label strong {
  color: var(--acid);
}
.check-row {
  margin-top: 12px;
}
.check-row label {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0;
  font-size: 0.84rem;
  color: var(--muted);
}
.check-row input {
  width: auto;
  accent-color: var(--acid);
}
.quick-ranges {
  margin: 8px 0 12px;
}
.advanced {
  border: 1px solid var(--line);
  border-radius: 16px;
  padding: 11px 12px;
  margin-top: 14px;
  background: rgba(255, 255, 255, 0.03);
}
.advanced,
.sysex-preview {
  transition:
    border-color 0.16s ease,
    background 0.16s ease;
}
.advanced:hover,
.sysex-preview:hover {
  border-color: rgba(255, 255, 255, 0.18);
  background: rgba(255, 255, 255, 0.04);
}
.sysex-preview {
  border: 1px solid var(--line);
  border-radius: 16px;
  padding: 11px 12px;
  margin-top: 14px;
  background: rgba(255, 255, 255, 0.03);
}
summary {
  cursor: pointer;
  font-weight: 900;
  color: #fff;
}
.step-grid {
  display: grid;
  grid-template-columns: repeat(8, minmax(0, 1fr));
  gap: 8px;
  margin-top: 12px;
}
.step-card {
  border: 1px solid var(--line);
  border-radius: 14px;
  padding: 9px;
  min-height: 96px;
  background: rgba(255, 255, 255, 0.045);
  display: flex;
  flex-direction: column;
  gap: 2px;
  transition:
    border-color 0.16s ease,
    background 0.16s ease,
    opacity 0.16s ease;
}
.step-card.active {
  border-color: rgba(214, 255, 79, 0.34);
}
.step-card.active:hover {
  border-color: rgba(214, 255, 79, 0.48);
  background: rgba(255, 255, 255, 0.055);
}
.step-card.inactive {
  opacity: 0.42;
}
.step-card.rest {
  background: rgba(255, 53, 93, 0.08);
}
.step-number {
  color: var(--acid);
  font-weight: 1000;
  font-size: 0.78rem;
}
.step-card strong {
  font-size: 1rem;
}
.flags {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 3px;
  margin-top: auto;
}
.flags span {
  text-align: center;
  border: 1px solid var(--line);
  border-radius: 999px;
  font-size: 0.58rem;
  color: rgba(255, 255, 255, 0.36);
  padding: 2px 0;
}
.flags span.on {
  color: #111;
  background: var(--acid);
  border-color: var(--acid);
  font-weight: 1000;
}
.sysex-preview pre {
  white-space: pre-wrap;
  word-break: break-word;
  font-family: "SFMono-Regular", Consolas, monospace;
  font-size: 0.7rem;
  line-height: 1.42;
  color: #cbeeff;
  max-height: 260px;
  overflow: auto;
}
.log-list {
  max-height: calc(100vh - 330px);
  overflow: auto;
  display: grid;
  gap: 7px;
}
.log {
  margin: 0;
  padding: 9px 11px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid var(--line);
  color: var(--muted);
  line-height: 1.32;
  font-size: 0.86rem;
  transition:
    border-color 0.16s ease,
    background 0.16s ease;
}
.log:hover {
  background: rgba(255, 255, 255, 0.055);
}
.log.ok {
  color: #eaffbd;
  border-color: rgba(214, 255, 79, 0.2);
}
.log.warn {
  color: #ffe3b5;
  border-color: rgba(255, 184, 77, 0.24);
}
.log.error {
  color: #ffd3dc;
  border-color: rgba(255, 53, 93, 0.35);
}
.log.info {
  color: #d6f9ff;
  border-color: rgba(115, 244, 255, 0.2);
}
.mini-list {
  display: grid;
  gap: 5px;
  max-height: calc(100vh - 330px);
  overflow: auto;
}
.mini-list p {
  margin: 0;
  color: var(--muted);
  line-height: 1.38;
  font-size: 0.86rem;
}
.mini-list strong {
  color: var(--acid);
}

::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}
::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.035);
  border-radius: 999px;
}
::-webkit-scrollbar-thumb {
  background: rgba(214, 255, 79, 0.24);
  border: 3px solid transparent;
  border-radius: 999px;
  background-clip: content-box;
}
::-webkit-scrollbar-thumb:hover {
  background: rgba(214, 255, 79, 0.38);
  border: 3px solid transparent;
  background-clip: content-box;
}

@keyframes fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes modal-in {
  from {
    opacity: 0;
    transform: translateY(6px) scale(0.985);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

@media (prefers-reduced-motion: reduce) {
  *,
  *:before,
  *:after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    scroll-behavior: auto !important;
    transition-duration: 0.01ms !important;
  }
}

@media (max-width: 1180px) {
  .workspace,
  .top-panel,
  .manual-grid,
  .activity-grid {
    grid-template-columns: 1fr;
  }
  .setup-panel,
  .main-panel {
    min-height: 0;
  }
  .tab-content {
    max-height: none;
  }
  .step-grid {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
}

@media (max-width: 760px) {
  .app-shell {
    width: min(100% - 16px, 1520px);
    padding-top: 8px;
  }
  .panel {
    padding: 14px;
    border-radius: 18px;
  }
  .write-card,
  .grid.two,
  .grid.three,
  .dump-map-toolbar,
  .map-entry,
  .map-footer,
  .slider-grid {
    grid-template-columns: 1fr;
  }
  .step-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  h1 {
    font-size: 2.4rem;
  }
  .big-red {
    font-size: 1.08rem;
  }
}

@media (max-width: 460px) {
  .step-grid {
    grid-template-columns: 1fr;
  }
  .tabbar,
  .manual-recipe-actions {
    width: 100%;
  }
  .tabbar button,
  .secondary,
  .segmented button {
    width: 100%;
  }
  h1 {
    font-size: 2rem;
  }
}
